// src/styles/iconStyles.js
import { styled } from 'baseui';
import {
  Send,
  HardDriveUpload,
  HardDriveDownload,
  Settings,
  Eraser,
  FileText,
  Home,
  Share2,
  MonitorPlay,
  Copy,
  View,
  SlidersHorizontal,
  Play,
  Pause,
  SkipBack,
  Rewind,
  FastForward,
  TimerReset,
  QrCode,
  StepForward,
  StepBack,
  CalendarClock,
  TimerOff,
  Maximize,
} from 'lucide-react';

export const SendIcon = styled(Send, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const HardDriveUploadIcon = styled(HardDriveUpload, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const HardDriveDownloadIcon = styled(HardDriveDownload, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const SettingsIcon = styled(Settings, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const EraserIcon = styled(Eraser, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const FileTextIcon = styled(FileText, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const HomeIcon = styled(Home, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const Share2Icon = styled(Share2, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const MonitorPlayIcon = styled(MonitorPlay, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const CopyIcon = styled(Copy, props => ({ ...props.iconStyle, width: `${props.$size}px`, height: `${props.$size}px` }));
export const ViewIcon = styled(View, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const ControlsIcon = styled(SlidersHorizontal, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const PlayIcon = styled(Play, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const PauseIcon = styled(Pause, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const PrevIcon = styled(Rewind, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const NextIcon = styled(FastForward, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));

export const LandscapePlayIcon = styled(Play, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const LandscapePauseIcon = styled(Pause, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const LandscapeResetIcon = styled(SkipBack, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const LandscapePrevIcon = styled(Rewind, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const LandscapeNextIcon = styled(FastForward, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const LandscapeResetAllIcon = styled(TimerReset, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));

export const ShareIcon = styled(Share2, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
export const QrCodeIcon = styled(QrCode, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));

const iconStyle = {
  width: 'clamp(1.25rem, 1.5vw, 1.5rem)',
  height: 'clamp(1.25rem, 1.5vw, 1.5rem)',
};
export const RefreshIcon = styled(TimerReset, iconStyle);
export const StepForwardIcon = styled(StepForward, iconStyle);
export const StepBackIcon = styled(StepBack, iconStyle);
export const SkipBackIcon = styled(SkipBack, iconStyle);
export const FastForwardIcon = styled(FastForward, iconStyle);
export const RewindIcon = styled(Rewind, iconStyle);
export const ClockPlayIcon = styled(CalendarClock, iconStyle);
export const TimerOffIcon = styled(TimerOff, iconStyle);
export const MaximizeIcon = styled(Maximize, props => ({ width: `${props.$size}px`, height: `${props.$size}px` }));
